<template>
  <v-dialog
    :value="isVisible"
    :transition="false"
    :max-width="400"
    :persistent="false"
    @click:outside="$emit('close')"
  >
    <FormInfoCategory
      v-if="isVisible"
      @submit="$emit('submit')"
      @cancel="$emit('close')"
    />
  </v-dialog>
</template>

<script>
import DialogAbstract from '@/components/abstract/dialog'
import FormInfoCategory from '@/pages/shared-access/form'

export default {
  name: 'FormDialog',
  components: {
    FormInfoCategory
  },
  extends: DialogAbstract,
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  }
}
</script>
